<p-table
  *ngIf="serviceHistory && serviceHistory.items"
  [headers]="headers"
  [items]="serviceHistory.items"
  [rowTemplate]="rowTemplate"
  [sortColumn]="'happened_at'"
  [sortDirection]="'desc'"
  (sortChanged)="onSortChanged($event)"
>
  <ng-template #rowTemplate let-item>
    <td class="padded-cell">
      {{ item.happenedAt | date: "dd/MM/yyyy à HH:mm" }}
    </td>
    <td [title]="item.name.description">{{ item.name.label }}</td>
    <td>{{ item.propertyType.label }}</td>
    <td>
      {{ item.street + ", " + item.city + ", " + item.postalCode | trim }}
    </td>
    <td *ngIf="canAccessReport">
      <a
        [href]="getFullServiceUrl(item.url)"
        class="text-secondary"
        title="Consulter"
      >
        <i-feather name="eye"></i-feather>
      </a>
    </td>
    <td *ngIf="canDownloadReport || canEditReport">
      <a
        *ngIf="canEditReport && item.reportId"
        class="text-secondary"
        title="Modifier"
        (click)="onEditReport(item)"
      >
        <i-feather name="edit"></i-feather>
      </a>
      <a
        *ngIf="canDownloadReport && item.reportId"
        class="text-secondary ms-2"
        title="Télécharger"
        (click)="onDownloadReport(item)"
      >
        <i-feather name="download"></i-feather>
      </a>
    </td>
  </ng-template>
</p-table>

<p-pagination
  [currentPage]="currentPage"
  [totalPages]="totalPages"
  [visiblePages]="3"
  (pageChanged)="onPageChanged($event)"
>
</p-pagination>
